import React from "react"
import Request from "../../Request"
import _ from "lodash"
import {debounce} from "throttle-debounce";
import {
    mobileNumber, serviceListArrNew, servingList
} from "../../components/_utils";
import {connect} from "react-redux";
import moment from "moment";
import {Modal, OverlayTrigger, Tooltip} from "react-bootstrap"
import PriceEstimateModal from "../../components/priceEstimateModal"
import {NotificationManager} from "react-notifications";
import PageBanner from "../../components/pageBanner"
import {Link} from "react-router-dom"
import "../../less/stylesheet/price-estimate.css"
import "../../less/stylesheet/section.css"
import "../../less/stylesheet/btns.css"
import Timer from "../../components/timer";
import CountryCodePicker from "../../components/countryCodePicker";
import Step1 from "./steps/step1";
import Step2 from "./steps/step2";
import Step3 from "./steps/step3";
import Faq from "../../components/newComps/faq";
import StepperComponent from "../../components/StepperComponent";
import Parser from "html-react-parser";

const valid = require("card-validator");
const collectionTypeList = {
    1: 'Contactless delivery', 2: 'I will meet driver\n'
}

const titleObj = {
    "0": "Check if we serve your area",
    "1": "Select Services",
    "2": "Schedule your pick up & drop off",
    "3": "One step away",
}
const descObj = {
    "0": "Enter your postcode, select your address and check if we serve your area", // "1": "Select your services, no need to itemize your order, we’ll do this for you after collection. Estimate the price of your order using the price estimator above.",
    "1": `Select your services, no need to itemize your order, we’ll do this for you after collection.<br/>Estimate the price of your order using the price estimator above.`,
    "2": "Select a day & time for your pick up and drop off",
    "3": "Fill out your contact details and complete your order",
}

const $ = window.$;

const loginUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
const initState = {
    slotId: "",
    categoryList: [],
    serviceList: [],
    cardNumber: loginUser && loginUser.paymentMethod && loginUser.paymentMethod.cardNumber ? loginUser.paymentMethod.cardNumber : '',
    expiryDate: loginUser && loginUser.paymentMethod && loginUser.paymentMethod.expiryDate ? loginUser.paymentMethod.expiryDate : '',
    cvv: loginUser && loginUser.paymentMethod && loginUser.paymentMethod.cvv ? loginUser.paymentMethod.cvv : '',
    name: '',
    mobile: '',
    email: '',
    password: '',
    selectedAddress: {},
    addressType: 'home',
    addressDetail: '',
    pickupTime: {},
    deliveryTime: {},
    visiblePriceEstimator: false,
    visibleHowItWorks: false,
    userId: loginUser && loginUser._id ? loginUser._id : '',
    stripe: loginUser && loginUser.stripe ? loginUser.stripe : '',
    showPromoCode: true,
    showDetails: true,
    promoCodeObj: {},
    additionalDetails: '',
    cardType: 'creditCard.svg',
    expiryDateIsValid: false,
    stripeCardNumber: '',
    hashTag: window.location.search,
    customerID: '',
    itsMobileSize: false,
    source: '',
    selectedCollectionType: null,
    selectedIndex: 0,
    showPromoCheckIcon: false,
    boxIndex: 0,
    isValidPromoCode: false,
    isMobileView: false,

    hearingFrom: undefined,
    hearingFromOther: "",
}
const hearingOptions = [
    'Google Search',
    'Google Maps',
    'Instagram',
    'Facebook',
    'TikTok',
    'Friend / Family Recommendation',
    'Leaflet',
    'Saw your van',
    'Passing by the shop',
    'Other'
]

class PlaceOrder extends React.Component {
    _isMounted = false;
    events = {
        loadUser: async () => {
            let {data} = await Request.getUser(loginUser);
            if (data && data.whoAreYouServing) {
                let selectedService = servingList.indexOf(data.whoAreYouServing)
                this.setState({selectedService})
            } else {
                // this.setState({selectedService: 0})
            }
        },

    }

    constructor(props) {
        super()
        this.state = {...initState}
        let urlParams = `step=1`
        if (loginUser && loginUser._id) {
            urlParams = urlParams + "&existing=1"
        } else {
            urlParams = urlParams + "&existing=0"
        }
        props.history.push(`/place-order?${urlParams}`);
        this.checkOutDebounce = debounce(1000, false, this._checkOutOrder);
    }

    async componentDidMount() {
        $("body").addClass("placeOrderPage orderPage");
        this._isMounted = true;
        if (this._isMounted) {
            let sessionId = new URL(window.location.href).searchParams.get('sessionId');
            /*if (!this.props.selectedAddress || (this.props.selectedAddress && !this.props.selectedAddress.viewAddress)) {
                // window.location.href = '/home'
            }*/
            if (sessionId) {
                let {success, data} = await Request.getSession({sessionId});
                if (success) {
                    this._loadAndSetParams(data, sessionId);
                } else {
                    // window.location.href = '/'
                    this._getCategory();
                }
            } else {
                this._getCategory();
                // window.location.href = '/'
            }
        }
        // this._getCategory();
        this.events.loadUser()

        this.updateViewport();
        window.addEventListener("resize", this.updateViewport);
    }

    updateViewport = () => {
        let isMobile = window.innerWidth <= 768
        this.setState({
            isMobileView: isMobile,
        });

        if (this.state.boxIndex == 3 && isMobile) {
            $(".footer-nero").addClass("footer150");
            $(".wa-float").addClass("bottom75");
        } else {
            $(".footer-nero").removeClass("footer150");
            $(".wa-float").removeClass("bottom75");
        }
    };


    _loadAndSetParams(data, sessionId) {
        this._checkScreen();
        this._getCategory();
        this.setState({
            slotId: data.slotId,
            selectedAddress: data.address,
            addressType: data.addressType ? data.addressType : 'home',
            addressDetail: data.addressDetail ? data.addressDetail : '',
            pickupTime: data.pickupTime,
            deliveryTime: data.deliveryTime,
            sessionId: sessionId,
            boxIndex: 1
        })
        this._getCustomer()
        const params = new URL(window.location.href).searchParams;
        const source = params.get('source');

        const referral_code = params.get('referral_code');
        let obj = {
            source,
        }
        if (this.state.hashTag && referral_code) {
            obj.promoCode = referral_code;
            obj.showPromoCode = true;
        }
        this.setState({...obj})
    }

    _checkScreen() {
        let windowWidth = window.innerWidth;
        if (windowWidth < 768) {
            this.setState({itsMobileSize: true})
        }
    }

    _setCustomerAndParams(data) {
        this._checkScreen();
        this.setState({
            slotId: data.slotId,
            singleSlot: data.singleSlot,
            selectedAddress: data.address,
            addressType: data.addressType,
            addressDetail: data.addressDetail
        })
        let urlParams = "step=2"
        if (loginUser && loginUser._id) {
            urlParams = urlParams + "&existing=1"
        } else {
            urlParams = urlParams + "&existing=0"
        }
        this.props.history.push(`/place-order?${urlParams}`);
        this._getCustomer()
        const params = new URL(window.location.href).searchParams;
        const source = params.get('source');
        let paramsStep = params.get('step');
        if (paramsStep) {
            paramsStep = paramsStep - 1;
        }
        const referral_code = params.get('referral_code');
        let obj = {
            source,
        }
        if (paramsStep) {
            obj.boxIndex = paramsStep;
        }
        if (this.state.hashTag && referral_code) {
            obj.promoCode = referral_code;
            obj.showPromoCode = true;
        }
        this.setState({...obj})
    }

    _setTimeAndParams = (data) => {
        let {isMobileView} = this.state;
        this.setState({
            pickupTime: data.pickupTime, deliveryTime: data.deliveryTime
        })
        let urlParams = "step=4"
        if (loginUser && loginUser._id) {
            urlParams = urlParams + "&existing=1"
        } else {
            urlParams = urlParams + "&existing=0"
        }
        this.props.history.push(`/place-order?${urlParams}`);
        let obj = {
            boxIndex: 3
        }
        this.setState({...obj});
        if (isMobileView) {
            $(".footer-nero").addClass("footer150");
            $(".wa-float").addClass("bottom75");
        }
    }

    _moveToTimePicker = (specialInstructions) => {
        this._checkScreen();
        let urlParams = "step=3"
        if (loginUser && loginUser._id) {
            urlParams = urlParams + "&existing=1"
        } else {
            urlParams = urlParams + "&existing=0"
        }
        this.props.history.push(`/place-order?${urlParams}`);
        this.setState({boxIndex: 2, specialInstructions})
    }

    goBackFxn = () => {
        let cloneState = _.clone(this.state);
        if (cloneState.boxIndex > 0) {
            let boxIndex = cloneState.boxIndex - 1;
            let urlParams = `step=${boxIndex + 1}`;
            if (loginUser && loginUser._id) {
                urlParams = urlParams + "&existing=1"
            } else {
                urlParams = urlParams + "&existing=0"
            }
            this.props.history.push(`/place-order?${urlParams}`);
            this.setState({
                boxIndex
            })
        }
        $(".footer-nero").removeClass("footer150");
        $(".wa-float").removeClass("bottom75");
    }
    goBackService = () => {
        let urlParams = `step=2`;
        if (loginUser && loginUser._id) {
            urlParams = urlParams + "&existing=1"
        } else {
            urlParams = urlParams + "&existing=0"
        }
        this.props.history.push(`/place-order?${urlParams}`);
        this.setState({
            boxIndex: 1
        })
        $(".footer-nero").removeClass("footer150");
        $(".wa-float").removeClass("bottom75");
    }

    async _getCategory() {
        let resp = await Request.getCategoryWithSubCategory({hideInOrder: true});
        /* this.setCategoryByParams(resp, (item) => {
             this.setState({categoryList: resp, serviceList: item})
         })*/
        this.setState({categoryList: serviceListArrNew, serviceList: []})

    }

    returnServiceList = (serviceList, index) => {
        this.setState({serviceList, selectedIndex: index})
    }

    async _checkOutOrder() {
        let {dispatch} = this.props;
        let obj = {
            ...this.state
        }

        if (!loginUser || (loginUser && !loginUser._id)) {

            if (!obj.name) {
                return NotificationManager.warning('Please enter Name');
            }

            if (!obj.mobile) {
                return NotificationManager.warning('Please enter Mobile Number');
            }

            if (!obj.email) {
                return NotificationManager.warning('Please enter Email');
            }
            if (obj.email.indexOf('@') < 0) {
                return NotificationManager.warning('Please enter valid Email');
            }
            if (!obj.password) {
                return NotificationManager.warning('Please enter Password');
            }
            if (obj.password.length < 6) {
                return NotificationManager.warning('Please enter min 6 digit password.');
            }

            if (!loginUser || (loginUser && !loginUser._id)) {
                if (!obj.hearingFrom) {
                    return NotificationManager.warning('Please choose How did you hear about us?');
                }
                if (obj.hearingFrom == "Other" && !obj.hearingFromOther) {
                    return NotificationManager.warning('Enter How did you hear about us?');
                }
            }
        }

        obj.address = obj.selectedAddress
        obj.paymentMethod = {
            name: obj.name, cardNumber: obj.cardNumber, expiryDate: obj.expiryDate, cvv: obj.cvv,
        }
        if (obj.selectedService !== undefined) {
            obj['whoAreYouServing'] = servingList[obj.selectedService]
        }

        if (obj.selectedCollectionType) {
            obj.collectionType = collectionTypeList[obj.selectedCollectionType]
        }

        dispatch({type: 'SHOW_LOADER'})
        let {success, user, message, token, orderInfo, orderId} = await Request.checkOut(obj);
        if (success) {
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            NotificationManager.success(message)
            this.setState({...initState});
            dispatch({
                type: 'SET_SERVICES_LIST', serviceList: obj.serviceList
            })
            dispatch({
                type: 'SET_CURRENT_USER', user: user
            })
            dispatch({type: 'HIDE_LOADER'});

            if (orderInfo) {
                window.location.href = `/order-success?type=brand-new&orderId=${orderId}`
            } else {
                window.location.href = `/order-success?type=existing&orderId=${orderId}`
            }
        } else {
            dispatch({type: 'HIDE_LOADER'})
            // this.setState({customerID})
            NotificationManager.error(message)
        }

    }

    getDateLabel(date) {
        date = moment(date).endOf('day')
        let today = moment().startOf('day')
        let label = ''
        if (date.diff(today, 'days') == 0) {
            return 'Today'
        } else if (date.diff(today, 'days') == 1) {
            return 'Tomorrow'
        } else {
            return date.format('dddd')
        }
    }

    getFullDate(date) {
        return date.format('ddd, MMM Do YYYY')
    }

    setAdditionalAddress(e) {
        let cloneAdd = _.clone(this.state.selectedAddress);
        cloneAdd.additionalDetails = e.target.value;
        this.setState({selectedAddress: cloneAdd})
    }

    handleClose = () => {
        this.setState({visiblePriceEstimator: false})
    }

    howItWorksClose = () => {
        this.setState({visibleHowItWorks: false})
    }

    showPromoCodeFxn() {
        this.setState({showPromoCode: !this.state.showPromoCode})
    }

    showDetailsFxn() {
        this.setState({showDetails: !this.state.showDetails})
    }

    async applyPromoCode() {
        let {promoCode} = this.state;
        if (!loginUser || (loginUser && !loginUser.customerID)) {
            return NotificationManager.warning("It must be verified at order completion.");
            return
        }
        let {customerID} = loginUser;
        this.props.dispatch({type: 'SHOW_LOADER'})
        let {success, message, Message} = await Request.applyPromoCode({promoCode, customerID});
        this.props.dispatch({type: 'HIDE_LOADER'})
        if (success) {
            this.setState({
                isValidPromoCode: true
            })
            return NotificationManager.success(Message);
        } else {
            this.setState({
                promoCode: "", isValidPromoCode: false
            })
            return NotificationManager.warning(message);
        }
    }

    clearPromoCode = () => {
        this.setState({
            promoCode: "", isValidPromoCode: false
        })
    }

    removePromoCode() {
        this.setState({
            promoCodeObj: {}, promoCode: ''
        })
    }

    componentWillUnmount() {
        $("body").removeClass("placeOrderPage orderPage");
        this._isMounted = false;
        window.removeEventListener("resize", this.updateViewport);
    }

    checkCardValidation() {
        let {cardNumber} = this.state;
        if (cardNumber) {
            let numberValidation = valid.number(cardNumber);
            if (numberValidation && numberValidation.card) {
                if (numberValidation.card.type == 'visa') {
                    this.setState({cardType: 'Visa.svg'})
                }
                if (numberValidation.card.type == 'mastercard') {
                    this.setState({cardType: 'Mastercard.svg'})
                }
                if (numberValidation.card.type !== 'mastercard' && numberValidation.card.type !== 'visa') {
                    this.setState({cardType: 'creditCard.svg'})
                }
            } else {
                if (cardNumber) {
                    this.setState({cardType: 'invalid.svg'})
                } else {
                    this.setState({cardType: 'creditCard.svg'})
                }
            }
        } else {
            this.setState({cardType: 'creditCard.svg'})
        }
    }

    checkExpiryDate() {
        let {expiryDate} = this.state;
        if (expiryDate) {
            expiryDate = expiryDate.replace('/', '')
            let numberValidation = valid.expirationDate(expiryDate);
            if (numberValidation) {
                this.setState({expiryDateIsValid: numberValidation.isValid})
            }
        } else {
            this.setState({expiryDateIsValid: false})
        }
    }


    async _getCustomer() {
        this.props.dispatch({type: 'SHOW_LOADER'})
        if (loginUser && loginUser._id) {
            let resp = await Request.getCustomerPaymentMethod();
            if (resp && resp.data) {
                let obj = {
                    paymentMethod: resp.data.paymentMethod, stripe: resp.data.stripe,
                };
                if (obj.paymentMethod && obj.paymentMethod.cardNumber && obj.paymentMethod.cvv) {
                    obj.paymentMethod.cvc = obj.paymentMethod.cvv
                }
                if (obj.paymentMethod && obj.paymentMethod.cardNumber && obj.paymentMethod.cvv && obj.paymentMethod.expiryDate) {
                    obj.changeAllow = false
                }
                obj = {...obj, ...obj.paymentMethod}
                this.setStripeCardNumber(obj.paymentMethod, obj.stripe, (respNew) => {
                    this.setState({...obj, userId: resp.data._id, ...respNew})
                    this.checkCardValidation()
                    this.checkExpiryDate()
                })
                this.props.dispatch({type: 'HIDE_LOADER'})
            } else {
                this.props.dispatch({type: 'HIDE_LOADER'})
            }
        } else {
            this.props.dispatch({type: 'HIDE_LOADER'})
        }
    }


    setPromoCode(e) {
        // this.setState({promoCode: e.target.value.toUpperCase()})
        this.setState({promoCode: e.target.value})
    }

    setStripeCardNumber(paymentMethod, stripe, callback) {
        if (paymentMethod && paymentMethod.cardNumber && stripe) {
            let splitData = paymentMethod.cardNumber.slice(0, 12)
            let splitData2 = paymentMethod.cardNumber.slice(12, 16)
            let x = 'X'
            splitData = x.repeat(splitData.length)
            return callback({stripeCardNumber: `${splitData}${splitData2}`})
        }

    }

    changeEmail() {
        this.setState({email: '', password: '', customerID: ''})
    }


    showMobileCheckout() {
        let obj = {
            ...this.state
        }
        if (!loginUser || (loginUser && !loginUser._id)) {

            if (!obj.name) {
                return NotificationManager.warning('Please enter Name');
            }

            if (!obj.mobile) {
                return NotificationManager.warning('Please enter Mobile Number');
            }

            if (!obj.email) {
                return NotificationManager.warning('Please enter Email');
            }
            if (obj.email.indexOf('@') < 0) {
                return NotificationManager.warning('Please enter valid Email');
            }
            if (!obj.password) {
                return NotificationManager.warning('Please enter Password');
            }
            if (obj.password.length < 6) {
                return NotificationManager.warning('Please enter min 6 digit password.');
            }

        }

        window.showMenuFxn()
    }

    async setUserInfo() {
        let {name, email, mobile, sessionId} = this.state;
        if (sessionId) {
            let resp = await Request.submitLeads({name, email, mobile, sessionId});
        }
    }

    _placeOrderCallback = (data) => {
        this._setCustomerAndParams(data)
    }

    selectService(key) {
        this.setState({selectedService: key})
    }

    render() {
        let {
            categoryList,
            serviceList,
            selectedAddress,
            addressType,
            addressDetail,
            pickupTime,
            deliveryTime,
            visiblePriceEstimator,
            showPromoCode,
            showDetails,
            additionalDetails,
            singleSlot,
            visibleHowItWorks,
            boxIndex,
            selectedService,
            isMobileView,
            hearingFrom,
            hearingFromOther,
        } = this.state;
        let renderTooltip = (message) => {
            return (<Tooltip id="button-tooltip">{message}</Tooltip>);
        }
        const renderImg = (img) => {
            return img == 'white' ? '/images/calendarWhite.png' : '/images/calendarDark.png'
        }


        return (<React.Fragment>
            <PageBanner style={{paddingTop: '2%', paddingBottom: '2%'}}>
                <div className={'overlayOrderDiv'}></div>
                <div className="barStyle bar-space-around">
                    <div className={'center'}>
                        <div className={'btnBlockAuth'}>
                            <div className="header-links">
                                {loginUser && loginUser._id ? (<Link to="/profile" className="header-item">
                                    <i className="fa fa-user-circle-o"></i> {loginUser.name}
                                </Link>) : (<Link to="/login" className="header-item">
                                    <i className="fa fa-user-circle-o"></i> LOG IN
                                </Link>)}

                                <div className="header-item">
                                    <Faq>
                                        <span><i className="fa fa-question-circle"/>FAQ's</span>
                                    </Faq>
                                </div>

                                <a className="header-item"
                                   onClick={() => this.setState({visiblePriceEstimator: true})}>
                                    <i className="fa fa-info-circle"></i>PRICE ESTIMATOR
                                </a>
                            </div>
                        </div>

                        <StepperComponent currentStep={boxIndex}/>

                    </div>
                </div>
                <div className="place-iner">
                    <h1 className="pending-title">{titleObj[boxIndex]}</h1>
                    <p className="subtitle-place">
                        {Parser(descObj[boxIndex])}
                        {/*Enter your postcode, select your address and check if we serve your area*/}
                    </p>
                </div>
            </PageBanner>
            <section id="tab-price" className="tab-price prstl mb-2"
                     style={{paddingBottom: 20}}>
                <div className="container">
                    <Step1
                        _placeOrderCallback={this._placeOrderCallback}
                        {...this.props}
                        boxIndex={boxIndex}
                        selectedAddress={selectedAddress}
                        singleSlot={singleSlot}
                        addressType={addressType}
                        addressDetail={addressDetail}
                    />
                    <Step2
                        categoryList={categoryList}
                        {...this.props}
                        selectedIndex={this.state.selectedIndex}
                        serviceList={serviceList}
                        specialInstructions={this.state.specialInstructions}
                        returnServiceList={this.returnServiceList}
                        boxIndex={boxIndex}
                        _moveToTimePicker={this._moveToTimePicker}
                        goBackFxn={this.goBackFxn}
                        isMobileView={isMobileView}
                    />

                    <Step3 _placeOrderCallback={this._setTimeAndParams}
                           goBackFxn={this.goBackFxn}
                           {...this.props}
                           boxIndex={boxIndex}
                           selectedAddress={selectedAddress}
                           singleSlot={singleSlot}
                           pickupTime={pickupTime}
                           deliveryTime={deliveryTime}
                    />

                    {boxIndex == 3 ? <div className="row">
                        <div className="col-md-12">
                            <Timer/>
                        </div>
                        <div className="col-md-8">
                            <div className="tab-content">

                                <div className="row pt-5 mb-3">
                                    <div className="col-md-6">
                                        <div className="tabs-header-colum mb-1">
                                            <h2>Order Details</h2>

                                        </div>
                                    </div>

                                    <div className="col-md-6 pt-0">
                                        <div className="butnad">
                                            <div className="pricelst more-inf">
                                                {/*  <button className="btn colrs"
                                                                onClick={() => this.setState({visiblePriceEstimator: true})}>
                                                            <i
                                                                className="fa fa-info-circle"></i> &nbsp;PRICE LIST
                                                        </button>
                                                        &nbsp;&nbsp;*/}
                                                <a className="btn colrs"
                                                   onClick={() => this.setState({visibleHowItWorks: true})}><i
                                                    className="fa fa-question-circle"></i> &nbsp;How it works
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                                <div className="row" id="hides">
                                    <div className="col-md-12">
                                        <div className="total-estimate-mb" id="myDIV" onClick={() => {
                                            this.showMobileCheckout()

                                        }}>
                                            <div className="total-estimate-mb place-order-summary place-order">
                                                {/*  <button className="btn btn-back"
                                                                id="show-hidden-menu">
                                                            <img src="/assets/img/arrow_left.svg"/> &nbsp; &nbsp;Back

                                                        </button>*/}

                                                <button className="detail-estimat  detail-estimat1 btn btn-my"
                                                        id="show-hidden-menu">
                                                        <span style={{textAlign: 'left'}}>
                                                        <h4>Next</h4>
                                                        <span>Order Summary</span>
                                                        </span>
                                                    <img src="/assets/img/arrow.svg"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-0">
                                    <div className="row">


                                        {!loginUser || (loginUser && !loginUser._id) ? <div className="col-md-12">
                                            <div className="box-colum box-colum-login">
                                                <div className="box-contants">
                                                    <h4 className="title mb-4"><a>LOGIN & PERSONAL
                                                        DETAILS</a>
                                                    </h4>
                                                    <div className="order-form">

                                                        <div className="row">
                                                            <div className="col-md-6 col-sm-12">
                                                                <div className="related-form">
                                                                    <input type="text"
                                                                           onChange={(e) => this.setState({name: e.target.value})}
                                                                           value={this.state.name}
                                                                           onBlur={() => this.setUserInfo()}
                                                                           className="pic-date form-control"
                                                                           placeholder="Name"/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6 col-sm-12">
                                                                <div style={{display: "flex", gap: 12}}>
                                                                    <div className="related-form">
                                                                        <CountryCodePicker
                                                                            countryCode={this.state.countryCode}
                                                                            onChange={(value) => {
                                                                                this.setState({countryCode: value})
                                                                            }}/>
                                                                    </div>
                                                                    <div className="related-form">
                                                                        <input type="text"
                                                                               onChange={(e) => this.setState({mobile: mobileNumber(e.target.value)})}
                                                                               value={this.state.mobile}
                                                                               onBlur={() => this.setUserInfo()}
                                                                               className="pic-date form-control"
                                                                               placeholder="Mobile Number"/>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div className="col-md-6 col-sm-12 ">
                                                                <div className="related-form">
                                                                    <input type="text"
                                                                           onChange={(e) => this.setState({email: e.target.value})}
                                                                           value={this.state.email}
                                                                           onBlur={() => this.setUserInfo()}
                                                                           className="pic-date form-control"
                                                                           placeholder="Email"/>

                                                                </div>
                                                            </div>

                                                            <div className="col-md-6 col-sm-12 ">
                                                                <div className="related-form">
                                                                    <input type="password"
                                                                           onChange={(e) => this.setState({password: e.target.value})}
                                                                           className="pic-date form-control"
                                                                           placeholder="Password For Future Login"/>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div> : <div className="col-md-12">
                                            <div className="box-colum">
                                                <div className="box-contants">
                                                    <h4 className="title mb-4"><a>LOGIN & PERSONAL
                                                        DETAILS</a></h4>
                                                    <div className="order-form userInfoBlock">
                                                        <div className="row">
                                                            <div className="col-md-3 col-sm-12">
                                                                <div className="related-form center">
                                                                    <img src={'/images/userCircle.png'}
                                                                         style={{height: 100}}/>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-9 col-sm-12">
                                                                <div className="related-form">
                                                                    <div className={'userInfo'}>
                                                                        {loginUser && loginUser.name ?
                                                                            <h4>{loginUser.name}</h4> : ''}
                                                                        <div className={'otherInfo'}>
                                                                            <h6><i
                                                                                className={'fa fa-envelope-o'}></i> {loginUser.email}
                                                                            </h6>
                                                                            <h6><i
                                                                                className={'fa fa-phone'}></i> {loginUser.mobile}
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>}
                                        <div className="col-md-12">
                                            <div className="box-colum collectionTypeHeight">
                                                <div className="box-contants collectionType">
                                                    <h4 className="title mb-4">
                                                        <a>How often you’re likely to use the service?</a>
                                                        <small style={{fontSize: 12}}>(<i>required</i>)</small>
                                                    </h4>
                                                    {/*<h6 className={'marginTop10'}>How often you’re likely to use the service? </h6>*/}
                                                    <div className="order-form questionBlock">
                                                        <div className={'service_list_grid'}>
                                                            {servingList.map((item, key) => {
                                                                return (<div key={key}>
                                                                    <div
                                                                        onClick={() => this.selectService(key)}
                                                                        className={`cardDiv ${selectedService == key ? 'select' : ''}`}>
                                                                        <div className={'iconDiv'}>
                                                                            <img
                                                                                src={selectedService == key ? renderImg('white') : renderImg('')}/>
                                                                        </div>
                                                                        <div className={'textDiv'}>
                                                                            <div className={'label'}>
                                                                                {item}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>)
                                                            })}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {loginUser && loginUser._id ? null :
                                            <div className="col-md-12">
                                                <div className="box-colum collectionTypeHeight hear-from">
                                                    <div className="box-contants collectionType">
                                                        <h4 className="title">
                                                            <a>How did you hear about us?</a>
                                                        </h4>
                                                        <h6 className={'marginTop10'} style={{color: "gray"}}>
                                                            We’re a local family-run laundry
                                                            service, so knowing how customers find us genuinely helps us
                                                            grow and improve.</h6>
                                                        <div className="order-form questionBlock">
                                                            <select
                                                                className={'form-control'}
                                                                value={hearingFrom}
                                                                onChange={({target}) => {
                                                                    this.setState({hearingFrom: target.value})
                                                                }}>
                                                                <option value={""}>Choose Option</option>
                                                                {hearingOptions.map((item) => {
                                                                    return (
                                                                        <option key={item} value={item}>{item}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                        </div>
                                                        {hearingFrom == "Other" ?
                                                            <textarea rows={3} value={hearingFromOther}
                                                                      placeholder={'Other*'}
                                                                      className={'form-control marginTop10'}
                                                                      onChange={({target}) => {
                                                                          this.setState({hearingFromOther: target.value})
                                                                      }}/> : null}
                                                    </div>
                                                </div>
                                            </div>}

                                        <div className={'col-md-12'}>
                                            <div className={'guaranteed-image-mobile'}>
                                                <img src={'../image2/guaranteed_checkout.png'}/>
                                            </div>
                                            {/*place-order hide_tab left*/}
                                            <div
                                                className={`place-order ${isMobileView ? "marginTop20" : "left"}`}>
                                                <a className={'btn btn-back'}
                                                   onClick={() => this.goBackFxn()}>
                                                    {/*Previous*/}
                                                    <img src="/assets/img/arrow-left.png"/> Back
                                                </a>
                                            </div>
                                        </div>


                                        {/* <div className="col-md-12 place-order mb-3 mt-0 display_mob_tab"
                                                     onClick={() => {
                                                         this.showMobileCheckout()
                                                     }}>
                                                    <button className="detail-estimat  detail-estimat1 btn btn-my"
                                                            id="show-hidden-menu">
                                                        <span style={{textAlign: 'left'}}>
                                                        <h4>Next</h4>
                                                        <span>Order Summary</span>
                                                        </span>

                                                        <img src="/assets/img/arrow.svg"/>
                                                    </button>
                                                </div>*/}


                                        {/*<div className="col-md-12 hide_tab">
                                                <div className="box-colum">
                                                    <h4 className="title"><a>FIRST TIME ORDERING?</a></h4>
                                                    <div className="box-contants">
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="ord-info__header">Item List</div>
                                                                <ul>
                                                                    <li>No need to itemize your order, we will do this
                                                                        for you
                                                                        once we have collected your order.
                                                                    </li>
                                                                    <li>After we have cleaned the order, we will process
                                                                        payment before delivering your order back to
                                                                        you.
                                                                    </li>
                                                                </ul>
                                                                <div className="ord-info__header">Prices</div>
                                                                <ul>
                                                                    <li>You can get an estimation of how much your order
                                                                        will cost using our price estimator above
                                                                    </li>
                                                                    <li>Minimum order is £20</li>
                                                                    <li>If you have any questions regarding payment, our
                                                                        customer care team will take care of your needs.
                                                                    </li>
                                                                </ul>
                                                                <div className="ord-info__header">Special Requirements
                                                                </div>
                                                                <ul>
                                                                    <li>{renderSpecialRequirement}</li>
                                                                </ul>
                                                                <div className="ord-info__header">Help</div>
                                                                <ul>
                                                                    <li>
                                                                        Still need help? Talk to one of our customer
                                                                        service agents here or email us at
                                                                        info@1stopwash.com.
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>*/}


                                    </div>
                                </div>


                                <div className="clearfix"></div>
                            </div>
                        </div>


                        <div className="col-md-4">
                            <div id="divMsg" className="price-calculator hidden-menu place-order-summary">
                                <div className={'price-calculator-list'}>
                                    <div className="top-calculator-head">
                                        <h1>Order Summary</h1>
                                        <a id="hides" onClick={() => window.hideMenuFxn()}>CLOSE</a>
                                    </div>
                                    <div className="mid-calculator mid-calculator1">

                                        <div className="pric-main-box">
                                            <div className="pric-cla-left-checklist" style={{width: "100%"}}>
                                                <i className={'fa fa-check-circle-o  yellow'}></i> &nbsp;
                                                <span
                                                    style={{letterSpacing: 1}}>Secure your collection slot</span>

                                            </div>
                                        </div>
                                        <div className="pric-main-box">
                                            <div className="pric-cla-left-checklist">
                                                <i className={'fa fa-check-circle-o  yellow'}></i> &nbsp;
                                                <span>Address</span>
                                                <div>
                                                    {selectedAddress ? selectedAddress.Label : ''}
                                                </div>
                                            </div>
                                            <div className="pric-cla-rigt"><p
                                                className="price-calcule">
                                                {/*Edit <i className={'fa fa-pencil'}></i>*/}
                                            </p></div>
                                        </div>
                                        <div id={'address-input'}>
                                            <input className={'search-query form-control '}
                                                   value={selectedAddress ? selectedAddress.additionalDetails : ''}
                                                   onChange={(e) => this.setAdditionalAddress(e)}
                                                   placeholder="Any building entrance advice? (optional)"
                                                   type="text"/>
                                        </div>
                                        <div className="pric-main-box">
                                            <div className="pric-cla-left-checklist">
                                                <i className={'fa fa-check-circle-o  yellow'}></i> &nbsp;
                                                <span>Pickup & Delivery</span>
                                                {pickupTime && pickupTime.date ?
                                                    <div className={'timeBlock related-form '}>
                                                        {/*<span className={'icon-truck-right'}></span>*/}
                                                        <b>{this.getFullDate(pickupTime.date)}</b>
                                                        <span>
                                                        {`${pickupTime.startTime}:00 -  ${pickupTime.endTime}:00`}
                                                    </span>
                                                    </div> : null}
                                                {deliveryTime && deliveryTime.date ?
                                                    <div className={'timeBlock related-form'}>
                                                        {/*<span className={'icon-truck-left'}></span>*/}
                                                        <b>{this.getFullDate(deliveryTime.date)}</b>
                                                        <span>
                                                        {`${deliveryTime.startTime}:00 -  ${deliveryTime.endTime}:00`}
                                                    </span>
                                                    </div> : null}
                                            </div>
                                            <div className="pric-cla-rigt"><p
                                                className="price-calcule">
                                                {/*Edit <i className={'fa fa-pencil'}></i>*/}
                                            </p></div>
                                        </div>
                                        <div>
                                            <div className="pric-main-box promoCode">
                                                <div className="pric-cla-left-checklist">
                                                    <i className={'fa fa-check-circle-o  yellow'}></i> &nbsp;
                                                    <span>PROMO CODE</span>
                                                </div>
                                            </div>
                                            <div className={'applyBtn'}>
                                                <a onClick={() => this.showPromoCodeFxn()}>
                                                    <i className={`fa ${showPromoCode ? 'fa-minus-circle' : 'fa-plus-circle'}`}></i> Apply
                                                    Promo Code
                                                </a>
                                            </div>
                                            {showPromoCode ? <div id={'address-input'}>
                                                <div className={'promoCodeBlock'} style={{height: 42}}>
                                                    <div className={'promoCodeInput related-form'}
                                                         style={{marginRight: 0}}>
                                                        <input className={'search-query form-control'}
                                                               id={'searchBox'}
                                                               value={this.state.promoCode}
                                                            // disabled={promoCodeObj && promoCodeObj.promoCodeId ? true : false}
                                                               onFocus={() => this.setState({showPromoCheckIcon: false})}
                                                               onBlur={() => this.setState({showPromoCheckIcon: true})}
                                                               placeholder="Promo Code"
                                                               disabled={this.state.isValidPromoCode}
                                                               onChange={(e) => this.setPromoCode(e)}
                                                        />
                                                        {this.state.isValidPromoCode ?
                                                            <i className={'fa fa-check check-icon'}></i> : null}

                                                        {/*{promoCodeObj && promoCodeObj.discount &&
                                                        <div className={'text'}>
                                                            You got {promoCodeObj.discount}% discount.
                                                        </div>}*/}
                                                    </div>

                                                    {/*   {promoCodeObj && promoCodeObj.promoCodeId ?
                                                                    <OverlayTrigger
                                                                        overlay={renderTooltip('Remove Promo Code')}>
                                                                        <a className={`btn btn-white circle`}
                                                                           onClick={() => this.removePromoCode()}>
                                                                            <i className={'fa fa-close'}></i>
                                                                        </a>
                                                                    </OverlayTrigger> :
                                                                    <OverlayTrigger
                                                                        overlay={renderTooltip('Apply Promo Code')}>
                                                                        <a className={`btn btn-white apply_btn`}
                                                                           onClick={() => this.applyPromoCode()}>
                                                                            Apply
                                                                        </a>
                                                                    </OverlayTrigger>}*/}

                                                    <OverlayTrigger
                                                        overlay={renderTooltip('Apply Promo Code')}>
                                                        <a className={`btn apply_btn`}
                                                           onClick={() => this.applyPromoCode()}>
                                                            Apply
                                                        </a>
                                                    </OverlayTrigger>

                                                </div>
                                                {this.state.isValidPromoCode ? <a className={'removeCodeBtn'}
                                                                                  onClick={this.clearPromoCode}>Remove
                                                    Promo
                                                    Code</a> : null}

                                            </div> : ''}
                                        </div>

                                        <div className={'marginTop20'}>
                                            <div className="pric-main-box promoCode">
                                                <div className="pric-cla-left-checklist">
                                                    <i className={'fa fa-check-circle-o  yellow'}></i> &nbsp;
                                                    <span>Order notes</span>
                                                </div>
                                            </div>
                                            <div className={'applyBtn'}>
                                                <a onClick={() => this.showDetailsFxn()}>
                                                    <i className={`fa ${showDetails ? 'fa-minus-circle' : 'fa-plus-circle'}`}></i>
                                                    Additional notes for order
                                                </a>
                                            </div>
                                            {showDetails && <div id={'address-input'}>
                                                <input className={'search-query form-control '}
                                                       value={additionalDetails}
                                                       onChange={(e) => this.setState({additionalDetails: e.target.value})}
                                                       placeholder="Additional Details"
                                                       type="text"/>
                                            </div>}


                                        </div>

                                    </div>
                                    {serviceList && serviceList.length ? <div className="pric-cla marginBottom30">
                                        {serviceList.map((item, key) => {
                                            return (<div className="pric-main-box-pro" key={key}>
                                                <div className="pric-cla-left-checklist">
                                                    <i className={'fa fa-check-circle-o  yellow'}></i> &nbsp;
                                                    <span>{item.name}</span>
                                                </div>
                                                <div className="pric-cla-rigt"
                                                     onClick={() => {
                                                         window.hideMenuFxn()
                                                         this.goBackService();
                                                     }}>
                                                    <p className="price-calcule">
                                                        <i className={'fa fa-pencil'}></i>
                                                    </p>
                                                </div>
                                            </div>)
                                        })}

                                    </div> : ''}

                                    <div className={'white'} style={{fontSize: 11}}>
                                        <div className={'mt-4'}>
                                            <i className={`fa fa-info-circle`}></i> &nbsp;
                                            By submitting your order, you agree to receive service and
                                            marketing-related auto-send texts from 1 Stop Wash.
                                            Opt-out anytime via your customer admin panel or by simply texting
                                            "STOP".
                                        </div>
                                    </div>
                                </div>

                                <div className="price-calcule-btn">
                                    <div className={'button-box'}>

                                        <button className="btn-cal-place btn-cal-place1"
                                                onClick={() => this.checkOutDebounce()}>Confirm pick up
                                            <img src="/assets/img/arrow-right.png" style={{height: 17}}/>
                                        </button>
                                        <div className={'satisfaction-msg'}>
                                            <small>100% Satisfaction Or Your Money Back</small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={'guaranteed-image'}>
                                <img src={'../image2/guaranteed_checkout.png'}/>
                            </div>
                            {/* <div className="box-bottom-cont"><p>*Please note that the final price may vary and it
                                    will be calculated after the cleaning process.</p></div>*/}

                        </div>
                    </div> : null}
                </div>
            </section>


            <PriceEstimateModal show={visiblePriceEstimator} handleClose={this.handleClose}
                                btnText={'Continue order'}
                                closeModal={this.handleClose}/>


            <Modal show={visibleHowItWorks} onHide={this.howItWorksClose}
                   centered
                   size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>How it works</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="rt-list element-four fqlsst p-4">
                        <ul className="mb-0">
                            <li>No need to itemize your order, we’ll do this for you. Simply inform the driver of
                                the services you'd like. Have one bag for each service e.g all wash &
                                fold in one bag, all dry cleaning in one bag etc.
                            </li>
                            <li>Use the Price list to estimate the price of your order.</li>

                        </ul>
                    </div>
                </Modal.Body>
            </Modal>

        </React.Fragment>)
    }

}


const mapStateToProps = ({global, router}) => ({
    slotId: global.slotId,
    selectedAddress: global.selectedAddress,
    pickupTime: global.pickupTime,
    deliveryTime: global.deliveryTime,
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PlaceOrder)
